const bp = {
  small: '576px',
  medium: '768px',
  large: '992px',
  xlarge: '1200px',
  heightMedium: '800px',
  heightSmall: '650px',
}

export default bp
